import OfficeHoursEdit from './office-hours-edit';

export default OfficeHoursEdit;
